import MultiSelect from "../../lib/multiSelectDropdown";
import { debounce } from "../../src/shared/Debounce";

const initLocationFilterMultiSelects = () => {
  document
    .querySelectorAll("#location-filters [data-multi-select-init='true']")
    .forEach((select) => {
      const element = select as HTMLSelectElement;
      if (element.dataset.multiSelectInitialized === "true") {
        return;
      }

      element.dataset.multiSelectInitialized = "true";

      const form = element.closest("form");

      if (form && form.dataset.multiSelectSubmitBound !== "true") {
        form.dataset.multiSelectSubmitBound = "true";

        form.addEventListener("submit", (event) => {
          event.preventDefault();

          submitForm(form);
        });
      }

      new MultiSelect(element, {
        onChange: () => {
          submitForm(form);
        },
      });
    });
};

const submitForm = debounce((form: HTMLFormElement | null) => {
  if (!form) {
    return;
  }

  const formData = new FormData(form);
  const url = new URL(
    form.action || window.location.href,
    window.location.origin
  );

  url.search = new URLSearchParams(
    formData as unknown as URLSearchParams
  ).toString();

  if (window.Turbo) {
    window.Turbo.visit(url.toString(), {
      frame: form.dataset.turboFrame,
    });

    return;
  }

  window.location.assign(url.toString());
}, 250);

export default initLocationFilterMultiSelects;
